import { forwardRef } from 'react';
import { Chip as MUIChip, ChipProps } from '@mui/material';

export { type ChipProps } from '@mui/material';

// eslint-disable-next-line react/display-name
export const Chip = forwardRef((props: ChipProps, ref: any) => {
  return <MUIChip ref={ref} {...props} />;
});
